import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

// --- DECLARAÇÃO GLOBAL PARA TYPESCRIPT ---
// Esta declaração informa ao TypeScript que a propriedade 'Pusher' será adicionada
// ao objeto 'window' global, evitando erros de tipo.
declare global {
    interface Window {
        Pusher: any;
    }
}

// Atribui a biblioteca Pusher ao objeto window para que o Laravel Echo possa encontrá-la.
window.Pusher = Pusher;

// Converte a string 'true' ou 'false' para um booleano
const forceTLS = process.env.REACT_APP_PUSHER_FORCE_TLS==="true";


// --- CONFIGURAÇÃO DAS CREDENCIAIS E ENDPOINTS ---

// A URL base da API é lida das variáveis de ambiente para suportar múltiplos ambientes.

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || process.env.REACT_APP_API_URL;


// As credenciais do Pusher devem ser armazenadas em variáveis de ambiente por segurança.
const PUSHER_APP_KEY = process.env.REACT_APP_PUSHER_APP_KEY || '71f61873b5bda70c2631';
const PUSHER_APP_CLUSTER = process.env.REACT_APP_PUSHER_APP_CLUSTER || 'sa1';

/**
 * @constant options
 * @description Objeto de configuração para a instância do Laravel Echo.
 */
const options = {
    // Define o Pusher como o 'broadcaster' (transmissor).
    // 'as const' garante que o TypeScript trate 'pusher' como um tipo literal, melhorando a segurança de tipos.
    broadcaster: 'pusher' as const,
    key: PUSHER_APP_KEY,
    cluster: PUSHER_APP_CLUSTER,
    //authEndpoint: '{BACKEND_URL}/broadcasting/auth',
    forceTLS: forceTLS, // Força o uso de TLS (HTTPS) para a conexão.
    
    // Endpoint para autorizar a escuta em canais privados ou de presença.
    // O Echo fará uma requisição a este endpoint para verificar se o usuário tem permissão.
    authEndpoint: `${BACKEND_URL}/broadcasting/auth`,
    
    // Configuração dos cabeçalhos para a requisição de autorização.
    auth: {
        headers: {
            // O token de autenticação é obtido dinamicamente do localStorage.
            // É crucial para que o backend possa identificar e autorizar o usuário.
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            Accept: 'application/json',
        },
    },
};

/**
 * @instance echo
 * @description Instância do Laravel Echo, pronta para ser usada em toda a aplicação
 * para escutar eventos transmitidos pelo backend.
 */
const echo = new Echo(options);

export default echo;
